import styled, { css } from 'styled-components'
import {
  height,
  HeightProps,
  margin,
  MarginProps,
  width,
  WidthProps,
} from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

type VariantProps = {
  strong?: boolean
  slight?: boolean
  invertedDefault?: boolean
  invertedSlight?: boolean
}

type DividerProps = WidthProps & HeightProps & MarginProps & VariantProps

const strongCss = ({ strong }: VariantProps) =>
  strong &&
  css`
    border-color: ${themeGet('colors.border.strong')};
  `

const slightCss = ({ slight }: VariantProps) =>
  slight &&
  css`
    border-color: ${themeGet('colors.border.slight')};
  `

const invertedSlightCss = ({ invertedSlight }: VariantProps) =>
  invertedSlight &&
  css`
    border-color: ${themeGet('colors.border.invertedSlight')};
  `

const invertedDefaultCss = ({ invertedDefault }: VariantProps) =>
  invertedDefault &&
  css`
    border-color: ${themeGet('colors.border.invertedDefault')};
  `

const shouldForwardProp = (prop: string | number) => {
  return ![
    ...DIV_SHOULD_FORWARD_PROP,
    'invertedSlight',
    'strong',
    'slight',
    'invertedDefault',
  ].includes(String(prop))
}

const Divider = styled.div.withConfig({
  shouldForwardProp,
})<DividerProps>`
  border-left: 1px solid ${themeGet('colors.border.default')};
  border-top: 1px solid ${themeGet('colors.border.default')};

  ${invertedDefaultCss}
  ${invertedSlightCss}
  ${slightCss}
  ${strongCss}

  ${width}
  ${height}
  ${margin}
`

export default Divider
